import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CheckboxGroupValidationErrors } from '@shared/validation/validation-errors.model';
import { filter, isEmpty, some, values } from 'lodash';

export const checkboxRequiredError: CheckboxGroupValidationErrors = { noneChecked: true };

export const checkboxesRequiredValidator =
  (): ValidatorFn =>
  (checkboxFormGroup: AbstractControl): CheckboxGroupValidationErrors | null => {
    const checkboxFormGroupValues = values(checkboxFormGroup.value);
    const areAllCheckboxFormGroupFieldsDisabled = isEmpty(checkboxFormGroupValues);
    const isSomeCheckboxFormGroupCheckboxFieldChecked = some(filter(checkboxFormGroupValues));

    return areAllCheckboxFormGroupFieldsDisabled || isSomeCheckboxFormGroupCheckboxFieldChecked
      ? null
      : checkboxRequiredError;
  };
